import { X, MessageCircle } from "lucide-react";
import { useEffect } from "react";

const RULES = [
  "Lütfen yalnızca ciddi ve gerçek kullanıcılar iletişime geçsin.",
  "Gereksiz mesaj, vakit kaybettirici içerik veya uygunsuz talepler dikkate alınmamaktadır.",
  "Platformumuz yalnızca reklam, tanıtım ve ilan yayınlama amacıyla hizmet vermektedir.",
  "Sitede yayınlanan tüm ilanlar ilan sahipleri tarafından oluşturulmakta olup içeriklerin doğruluğu tamamen paylaşımı yapan kişilerin sorumluluğundadır.",
  "Site yönetimi kullanıcılar arasında gerçekleşen konuşma, anlaşma, ödeme, buluşma veya herhangi bir iletişimden sorumlu tutulamaz.",
  "Sahte hesap, dolandırıcılık, tehdit, hakaret veya yasa dışı faaliyet tespit edilmesi durumunda gerekli işlemler uygulanabilir.",
  "Platform içerisinde yer alan tüm içerikler yetişkin bireylere yöneliktir ve yalnızca 18 yaş üzeri kullanıcıların erişimine açıktır.",
  "Siteyi kullanan herkes kullanım şartlarını ve sorumluluk kurallarını kabul etmiş sayılır.",
];

export default function ContactModal({ open, onClose, waLink, displayPhone }) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    if (open) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="np-modal" data-testid="contact-modal" onClick={onClose}>
      <div className="np-modal-box" onClick={(e) => e.stopPropagation()}>
        <button className="np-modal-x" onClick={onClose} aria-label="Kapat" data-testid="modal-close">
          <X size={20} strokeWidth={2.5} />
        </button>

        <h2 className="np-modal-title">
          BİZİMLE İLETİŞİME GEÇMEK İÇİN
          <br />
          AŞAĞIDAKİ WHATSAPP NUMARASINA MESAJ GÖNDERİNİZ
        </h2>

        <ul className="np-modal-rules">
          {RULES.map((r, i) => (
            <li key={i}>{r}</li>
          ))}
        </ul>

        <a
          href={waLink}
          target="_blank"
          rel="noopener noreferrer"
          className="np-modal-wa"
          data-testid="modal-wa-btn"
        >
          <MessageCircle size={20} strokeWidth={2.5} />
          <span>{displayPhone || "WHATSAPP'TAN MESAJ GÖNDER"}</span>
        </a>
      </div>
    </div>
  );
}
